import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
/**
 * @internal
 */
export const calendarClassNames = {
  root: 'fui-Calendar',
  divider: 'fui-Calendar__divider',
  goTodayButton: 'fui-Calendar__goTodayButton',
  monthPickerWrapper: 'fui-Calendar__monthPickerWrapper',
  liveRegion: 'fui-Calendar__liveRegion'
};
const useRootStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw",
    a9b677: "f13dwy2t"
  },
  normalize: {
    E5pizo: "f1couhl3",
    B7ck84d: "f1ewtqcl",
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f11qmguv", "f1tyq0we"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"],
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"]
  },
  monthPickerNotVisible: {
    Beiy3e4: "f1vx9l62"
  },
  dayAndMonthPickersVisible: {
    a9b677: "fcy5b15"
  },
  dayPickerVisibleAndWeekNumbersShown: {
    a9b677: "fhsg0in"
  },
  dayAndMonthPickersVisibleAndWeekNumbersShown: {
    a9b677: "fcarq7f"
  }
}, {
  d: [".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".f13dwy2t{width:220px;}", ".f1couhl3{box-shadow:none;}", ".f1ewtqcl{box-sizing:border-box;}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".fcy5b15{width:440px;}", ".fhsg0in{width:250px;}", ".fcarq7f{width:470px;}"]
});
const useDividerStyles = /*#__PURE__*/__styles({
  base: {
    g2u3we: "f68mrw8",
    h3c5rm: ["f7pw515", "fw35ms5"],
    B9xav0g: "frpde29",
    zhjwy3: ["fw35ms5", "f7pw515"],
    Bekrc4i: ["f1hqa2wf", "finvdd3"],
    vrafjx: ["fcdblym", "fjik90z"],
    Bhzewxz: "f15twtuk"
  }
}, {
  d: [".f68mrw8{border-top-color:var(--colorNeutralStroke2);}", ".f7pw515{border-right-color:var(--colorNeutralStroke2);}", ".fw35ms5{border-left-color:var(--colorNeutralStroke2);}", ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".f15twtuk{top:0;}"]
});
const useMonthPickerWrapperStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62"
  }
}, {
  d: [".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}"]
});
const useGoTodayButtonStyles = /*#__PURE__*/__styles({
  base: {
    qb2dma: "fpydfdc",
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    B5kzvoi: "f1yab3r1",
    B7ck84d: "f1e4lqlz",
    sj55zd: "f19n0e5",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "f1tvdnth",
    Bg96gwp: "fpfng1i",
    t21cq0: ["f17vyym1", "fb5scp"],
    B6of3ja: "f4gg0ds",
    B68tc82: "f1mtd64y",
    Bmxbyg5: "f1y7q3j9",
    z8tnut: "f1g0x7ka",
    z189sj: ["f8wuabp", "fycuoez"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["fycuoez", "f8wuabp"],
    seuwu7: "fvy6vk6",
    Jwef8y: "f9ql6rf",
    Bi91k9c: "f1f1pb61",
    eoavqd: "f8491dx",
    B2d53fq: "fc9d3oc",
    Dyrjrp: "f1cqwcg4",
    Be90el1: "fmjaa5u"
  }
}, {
  d: [".fpydfdc{-webkit-align-self:flex-end;-ms-flex-item-align:flex-end;align-self:flex-end;}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f1yab3r1{bottom:0;}", ".f1e4lqlz{box-sizing:content-box;}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".f1tvdnth{height:30px;}", ".fpfng1i{line-height:30px;}", ".f17vyym1{margin-right:16px;}", ".fb5scp{margin-left:16px;}", ".f4gg0ds{margin-top:3px;}", ".f1mtd64y{overflow-x:visible;}", ".f1y7q3j9{overflow-y:visible;}", ".f1g0x7ka{padding-top:0;}", ".f8wuabp{padding-right:4px;}", ".fycuoez{padding-left:4px;}", ".f1qch9an{padding-bottom:0;}", ".fvy6vk6 div{font-size:var(--fontSizeBase200);}", ".f1cqwcg4:disabled{color:var(--colorNeutralForegroundDisabled);}", ".fmjaa5u:disabled{pointer-events:none;}"],
  h: [".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}", ".f1f1pb61:hover{color:var(--colorBrandForeground1);}", ".f8491dx:hover{cursor:pointer;}", ".fc9d3oc:hover:active{color:var(--colorBrandForeground2);}"]
});
const useLiveRegionStyles = /*#__PURE__*/__styles({
  base: {
    B4j52fo: "fre7gi1",
    Bekrc4i: ["f1358rze", "f1rvrf73"],
    Bn0qgzm: "fqdk4by",
    ibv6hh: ["f1rvrf73", "f1358rze"],
    Bqenvij: "f1mpe4l3",
    B6of3ja: "fkrn0sh",
    t21cq0: ["f179hvsh", "f1538868"],
    jrapky: "fmxx68s",
    Frg6f3: ["f1538868", "f179hvsh"],
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    qhf8xq: "f1euv43f",
    a9b677: "frkrog8"
  }
}, {
  d: [".fre7gi1{border-top-width:0;}", ".f1358rze{border-right-width:0;}", ".f1rvrf73{border-left-width:0;}", ".fqdk4by{border-bottom-width:0;}", ".f1mpe4l3{height:1px;}", ".fkrn0sh{margin-top:-1px;}", ".f179hvsh{margin-right:-1px;}", ".f1538868{margin-left:-1px;}", ".fmxx68s{margin-bottom:-1px;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".f1euv43f{position:absolute;}", ".frkrog8{width:1px;}"]
});
/**
 * @internal
 *
 * Apply styling to the Calendar slots based on the state
 */
export const useCalendarStyles_unstable = props => {
  const rootStyles = useRootStyles();
  const dividerStyles = useDividerStyles();
  const monthPickerWrapperStyles = useMonthPickerWrapperStyles();
  const goTodayButtonStyles = useGoTodayButtonStyles();
  const liveRegionStyles = useLiveRegionStyles();
  const {
    className,
    isDayPickerVisible,
    isMonthPickerVisible,
    showWeekNumbers
  } = props;
  return {
    root: mergeClasses(calendarClassNames.root, rootStyles.base, rootStyles.normalize, !isMonthPickerVisible && rootStyles.monthPickerNotVisible, isDayPickerVisible && isMonthPickerVisible && !showWeekNumbers && rootStyles.dayAndMonthPickersVisible, isDayPickerVisible && !isMonthPickerVisible && showWeekNumbers && rootStyles.dayPickerVisibleAndWeekNumbersShown, isDayPickerVisible && isMonthPickerVisible && showWeekNumbers && rootStyles.dayAndMonthPickersVisibleAndWeekNumbersShown, className),
    divider: mergeClasses(calendarClassNames.divider, dividerStyles.base),
    monthPickerWrapper: mergeClasses(calendarClassNames.monthPickerWrapper, monthPickerWrapperStyles.base),
    goTodayButton: mergeClasses(calendarClassNames.goTodayButton, goTodayButtonStyles.base),
    liveRegion: mergeClasses(calendarClassNames.liveRegion, liveRegionStyles.base)
  };
};
//# sourceMappingURL=useCalendarStyles.js.map